import type { VocabularyGridBlock, SourceLanguageCode } from '@ellie/shared';
import { SOURCE_LANGUAGES, TARGET_LANGUAGES } from '@ellie/shared';
import { BlockHeader } from '../BlockHeader';
import { NativeHint } from '../NativeHint';

interface Props {
  block: VocabularyGridBlock;
  index: number;
  nativeLanguage: SourceLanguageCode;
  targetLanguage: string;
  pageNumber: number;
}

export function VocabularyGridPreview({
  block,
  index,
  nativeLanguage,
  targetLanguage,
  pageNumber,
}: Props) {
  const target = TARGET_LANGUAGES.find((l) => l.code === targetLanguage);
  const native = SOURCE_LANGUAGES.find((l) => l.code === nativeLanguage);

  const targetHeader = `${target?.flag ?? ''} ${target?.name ?? targetLanguage}`;
  const nativeHeader = `${native?.flag ?? ''} ${native?.name ?? nativeLanguage}`;

  return (
    <div className="wb-page">
      <BlockHeader block={block} index={index} />

      <div className="wb-block-instructions">
        <span className="wb-icon">{'\u{270F}\u{FE0F}'}</span>
        <div>
          <p>{block.instructions}</p>
          <NativeHint
            text={block.instructionsNative}
            nativeLanguage={nativeLanguage}
            label={targetLanguage.toUpperCase()}
          />
        </div>
      </div>

      <div className="wb-vocab-grid">
        <div className="wb-vocab-grid-header">{targetHeader}</div>
        <div className="wb-vocab-grid-header">{nativeHeader}</div>

        {block.items.map((item, i) => (
          <div key={i} className="wb-vocab-row">
            <div className={`wb-vocab-cell${item.hideTarget ? ' wb-blank' : ''}`}>
              {!item.hideTarget && (
                <>
                  {item.target}
                  {item.gender && <span className="wb-gender">({item.gender})</span>}
                  {item.example && (
                    <span className="wb-vocab-example">&ldquo;{item.example}&rdquo;</span>
                  )}
                </>
              )}
            </div>
            <div className={`wb-vocab-cell${item.hideNative ? ' wb-blank' : ''}`}>
              {!item.hideNative && item.native}
            </div>
          </div>
        ))}
      </div>

      <span className="wb-page-number">{pageNumber}</span>
    </div>
  );
}
